import Axios from "@/plugins/Axios";

export class BancoHorasService {
  async getMeuSaldo() {
    const response = await Axios().get("/ponto-colaboradores/banco-horas/meu-saldo");
    return response.data;
  }

  async getMeuHistorico(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/banco-horas/meu-historico", {
      params,
    });
    return response.data;
  }

  async getAdminSaldos(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/admin/banco-horas/saldos", {
      params,
    });
    return response.data;
  }

  async getAdminPendencias(params = {}) {
    const response = await Axios().get("/ponto-colaboradores/admin/banco-horas/pendencias", {
      params,
    });
    return response.data;
  }

  async aprovar(id, data = {}) {
    const response = await Axios().post(
      `/ponto-colaboradores/admin/banco-horas/${id}/aprovar`,
      data
    );
    return response.data;
  }

  async reprovar(id, data = {}) {
    const response = await Axios().post(
      `/ponto-colaboradores/admin/banco-horas/${id}/reprovar`,
      data
    );
    return response.data;
  }

  async processar(params = {}) {
    const response = await Axios().post("/ponto-colaboradores/admin/banco-horas/processar", params);
    return response.data;
  }

  // ---- Justificativa de hora extra (colaborador) ----

  async getHorasExtrasParaJustificar() {
    const response = await Axios().get(
      "/ponto-colaboradores/horas-extras-justificativas/pendentes"
    );
    return response.data;
  }

  /** Cria ou atualiza; formData com motivo, anexo (opcional) e remover_anexo. */
  async salvarJustificativaHoraExtra(movimentacaoId, formData) {
    const response = await Axios().post(
      `/ponto-colaboradores/horas-extras-justificativas/${movimentacaoId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  }

  async excluirJustificativaHoraExtra(movimentacaoId) {
    await Axios().delete(`/ponto-colaboradores/horas-extras-justificativas/${movimentacaoId}`);
  }

  async abrirMeuAnexoJustificativa(movimentacaoId) {
    await this.abrirArquivo(
      `/ponto-colaboradores/horas-extras-justificativas/${movimentacaoId}/anexo`,
      `justificativa_hora_extra_${movimentacaoId}`
    );
  }

  async abrirAnexoJustificativaGestao(movimentacaoId) {
    await this.abrirArquivo(
      `/ponto-colaboradores/admin/banco-horas/${movimentacaoId}/justificativa/anexo`,
      `justificativa_hora_extra_${movimentacaoId}`
    );
  }

  async abrirArquivo(url, nomeArquivo) {
    const response = await Axios().get(url, { responseType: "arraybuffer" });
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const blobUrl = window.URL.createObjectURL(blob);
    const novaAba = window.open(blobUrl);
    if (!novaAba) {
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = nomeArquivo;
      link.click();
    }
  }

  async getUsuarioHistorico(userId, params = {}) {
    const response = await Axios().get(
      `/ponto-colaboradores/admin/banco-horas/usuario/${userId}/historico`,
      {
        params,
      }
    );
    return response.data;
  }
}

export default new BancoHorasService();
